/**
 *  单据编号自动生成
 * @param {(string)}
 * @param {string} cFormat
 * @returns {string}
 */
import { parseTime } from "@/utils";
export function getDocumentCode(data) {
    const date = parseTime(new Date(), "{y}{m}{d}{h}{i}{s}");
    console.log(date);
    const number = 10 + Math.floor(Math.random() * (90))
    console.log(number);
    return data + date + number
}
